"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ContentLayout = require("./ContentLayout");
Object.keys(_ContentLayout).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ContentLayout[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ContentLayout[key];
    }
  });
});